
import React from 'react';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Link } from 'lucide-react';
import { Control } from "react-hook-form";

interface QuoteLinkFieldProps {
  control: Control<any>;
  isLoading: boolean;
}

const QuoteLinkField: React.FC<QuoteLinkFieldProps> = ({
  control,
  isLoading
}) => {
  return (
    <FormField
      control={control}
      name="quoteLink"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            <Link className="w-4 h-4" />
            Quote Link (Optional)
          </FormLabel>
          <FormControl>
            <Input 
              placeholder="https://example.com/quote" 
              {...field} 
              disabled={isLoading}
              type="url"
            />
          </FormControl>
          <FormDescription>
            Provide a link to an external quote document or resource.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuoteLinkField;
